"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyseList = analyseList;
exports.findNextItem = findNextItem;
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _identity = _interopRequireDefault(require("lodash/fp/identity"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _tabbable = require("tabbable");
function findNextIndex(circularMove, current, direction, itemCount) {
  var lastIndex = itemCount - 1;
  function forward() {
    var nextIndex = (0, _isNil["default"])(current) ? 0 : current + 1;
    if (nextIndex > lastIndex) {
      return circularMove ? 0 : lastIndex;
    }
    return nextIndex;
  }
  function backward() {
    var nextIndex = (0, _isNil["default"])(current) ? lastIndex : current - 1;
    if (nextIndex < 0) {
      return circularMove ? lastIndex : 0;
    }
    return nextIndex;
  }
  return direction === 'forward' ? forward() : backward();
}
function defaultTo(defaults) {
  return function (index) {
    return index > -1 ? index : defaults;
  };
}

/**
* @internal
* */
function analyseList(_ref) {
  var current = _ref.current,
    container = _ref.container,
    idAttribute = _ref.idAttribute,
    _ref$itemFilter = _ref.itemFilter,
    itemFilter = _ref$itemFilter === void 0 ? _identity["default"] : _ref$itemFilter;
  var candidates = (0, _compose["default"])(idAttribute ? (0, _filter["default"])(function (item) {
    return item.hasAttribute(idAttribute);
  }) : _identity["default"], (0, _filter["default"])(itemFilter), _tabbable.focusable)(container);
  var currentIndex = idAttribute ? defaultTo(null)(candidates.findIndex(function (item) {
    return item.getAttribute(idAttribute) === current;
  })) : current;
  var currentElement = (0, _isNil["default"])(currentIndex) ? null : candidates.at(currentIndex);
  return {
    candidates: candidates,
    currentIndex: currentIndex,
    currentElement: currentElement
  };
}

/**
* Find next focusable item in the list.
*
* Note: when "idAttribute" is provided, the "current" and the first item in the
* return value should be item id. Otherwise they are item index.
* */
function findNextItem(_ref2) {
  var _ref3, _candidates$at, _candidates$at2;
  var circularMove = _ref2.circularMove,
    container = _ref2.container,
    current = _ref2.current,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'forward' : _ref2$direction,
    idAttribute = _ref2.idAttribute,
    itemFilter = _ref2.itemFilter;
  var _analyseList = analyseList({
      current: current,
      container: container,
      idAttribute: idAttribute,
      itemFilter: itemFilter
    }),
    candidates = _analyseList.candidates,
    currentIndex = _analyseList.currentIndex;
  var nextIndex = findNextIndex(!!circularMove, currentIndex, direction, candidates.length);
  return [(_ref3 = idAttribute ? (_candidates$at = candidates.at(nextIndex)) === null || _candidates$at === void 0 ? void 0 : _candidates$at.getAttribute(idAttribute) : nextIndex) !== null && _ref3 !== void 0 ? _ref3 : null, (_candidates$at2 = candidates.at(nextIndex)) !== null && _candidates$at2 !== void 0 ? _candidates$at2 : null];
}